<div class="global-container" [slptLoadingMask]="false" [config]="loaderConfig">
  <prtl-dashboard-layout>
    <prtl-sidebar class="dashboard-layout-sidebar"></prtl-sidebar>
    <prtl-header class="dashboard-layout-header"></prtl-header>
    <router-outlet class="dashboard-layout-main"></router-outlet>
  </prtl-dashboard-layout>
</div>
